import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { HeartOff, ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-5">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center max-w-lg"
        data-testid="payment-cancel-page"
      >
        <HeartOff className="text-zinc-500 mx-auto mb-6" size={56} />
        <h1 className="font-display uppercase text-5xl text-white">Donation cancelled</h1>
        <p className="font-sub text-lg text-zinc-400 mt-4">
          No charge was made. Whenever you're ready, the streets are still waiting — and every
          gift counts.
        </p>
        <Link
          to="/"
          data-testid="cancel-back-home"
          className="btn-fill inline-flex items-center gap-2 mt-10 border border-green text-green font-sub font-semibold px-8 py-3.5 rounded-full"
        >
          <ArrowLeft size={18} /> Back home
        </Link>
      </motion.div>
    </div>
  );
}
